export const DocumentVisibilityState = {
  hidden: 'hidden',
  visible: 'visible',
};
